import React, { useState } from 'react';
import './ClassroomEnhanced.css';

const IdeaBoard = ({ ideas = [], onSubmitIdea, onCheerIdea, user }) => {
  const [ideaText, setIdeaText] = useState('');
  const [category, setCategory] = useState('idea');
  const canPost = user?.type === 'student' || user?.type === 'coach';

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!ideaText.trim()) return;
    onSubmitIdea?.(ideaText.trim(), category);
    setIdeaText('');
  };

  return (
    <section className="idea-board">
      <div className="section-heading">
        <div>
          <p className="eyebrow">Co-create</p>
          <h3>Idea board & shout-outs</h3>
        </div>
      </div>

      {canPost && (
        <form className="idea-form" onSubmit={handleSubmit}>
          <textarea
            value={ideaText}
            onChange={(e) => setIdeaText(e.target.value)}
            placeholder="Drop a new idea, question, or celebration!"
            rows={3}
          />
          <div className="idea-form-actions">
            <select value={category} onChange={(e) => setCategory(e.target.value)}>
              <option value="idea">Idea 💡</option>
              <option value="question">Question ❓</option>
              <option value="shoutout">Shout-out 🎉</option>
            </select>
            <button type="submit" className="cta primary" disabled={!ideaText.trim()}>
              Share with class
            </button>
          </div>
        </form>
      )}

      <div className="ideas-list">
        {ideas.length === 0 ? (
          <p className="idea-empty">No posts yet. Be the first to start the conversation! 🗨️</p>
        ) : (
          ideas.map((idea) => (
            <article key={idea.id} className={`idea-card idea-${idea.category || 'idea'}`}>
              <header>
                <strong>{idea.authorName || 'Learner'}</strong>
                <span className="idea-category">{idea.category || 'idea'}</span>
              </header>
              <p>{idea.text}</p>
              <footer>
                <span className="idea-time">
                  {idea.createdAt?.toDate?.()?.toLocaleString?.() || ''}
                </span>
                <button type="button" onClick={() => onCheerIdea?.(idea.id)}>
                  👏 {idea.cheers || 0}
                </button>
              </footer>
            </article>
          ))
        )}
      </div>
    </section>
  );
};

export default IdeaBoard;
